import React from 'react';

// Components
import { UserProfileSelectionListItem } from './partials/UserProfileSelectionListItem';

type UserProfileSelectionProps = {
  headline: React.ReactElement | string;
  helpText?: string;
  profileLink?: string;
  profileLinkText?: string;
  logoutLink?: string;
  logoutLinkText?: string;
  loginLink?: string;
  loginLinkText?: string;
  disableReadAllModeLink?: string;
  disableReadAllModeLinkText?: string;
  enableReadAllModeLink?: string;
  enableReadAllModeLinkText?: string;
};

/**
 * The component aggregates contents from UserAccount or UserAnonymous to this point,
 * where all the design (CSS) is based
 */
export function UserProfileSelection(props: UserProfileSelectionProps) {
  // no empty ul and no heading without content beneath
  if (!props.profileLink && !props.logoutLink && !props.loginLink && !props.disableReadAllModeLink) {
    return null;
  }
  return (
    <div id="user-profile-selection" className="user-profile-selection">
      <h3 className="user-profile-selection__headline">{props.headline}</h3>
      {props.helpText ? <p className="user-profile-selection__helptext">{props.helpText}</p> : null}
      <ul className="user-profile-selection__list">
        <UserProfileSelectionListItem to={props.profileLink}>
          {props.profileLinkText}
        </UserProfileSelectionListItem>
        <UserProfileSelectionListItem to={props.disableReadAllModeLink} routing={false}>
          {props.disableReadAllModeLinkText}
        </UserProfileSelectionListItem>
        <UserProfileSelectionListItem to={props.enableReadAllModeLink} routing={false}>
          {props.enableReadAllModeLinkText}
        </UserProfileSelectionListItem>
        <UserProfileSelectionListItem to={props.logoutLink} routing={false}>
          {props.logoutLinkText}
        </UserProfileSelectionListItem>
        <UserProfileSelectionListItem to={props.loginLink} routing={false}>
          {props.loginLinkText}
        </UserProfileSelectionListItem>
      </ul>
    </div>
  );
}
